import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Toggle from 'react-toggle';
import cx from 'classnames';

// Styles
import './styles/toggle-switch.scss';

class ToggleSwitch extends Component {
    static defaultProps = {
        busyIconCls: 'fluid-icon-spinner2',
        disabled: false,
        isDisabled: false,
        busy: false,
        isBusy: false,
        checked: false,
        isChecked: false,
        icons: true,
        onChange: () => Promise.resolve(),
    };

    static propTypes = {
        busyIconCls: PropTypes.string,
        contextCls: PropTypes.string,
        id: PropTypes.string,
        name: PropTypes.string,
        value: PropTypes.string,
        disabled: PropTypes.bool,
        isDisabled: PropTypes.bool,
        busy: PropTypes.bool,
        isBusy: PropTypes.bool,
        checked: PropTypes.bool,
        isChecked: PropTypes.bool,
        icons: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
        onChange: PropTypes.func,
    };

    render() {
        const {
            busyIconCls,
            contextCls,
            busy,
            isBusy,
            checked,
            isChecked,
            icons,
        } = this.props;
        const toggleProps = this.getProps();
        const busyModCls = {
            [`${this.baseCls}__icon-busy--checked`]: isChecked || checked,
        };

        return (
            <div className={cx(this.baseCls, contextCls)}>
                {(isBusy || busy) && (
                    <span
                        className={cx(
                            `${this.baseCls}__icon-busy`,
                            busyModCls,
                            busyIconCls,
                        )}
                    />
                )}
                <Toggle
                    {...toggleProps}
                    className={`${this.baseCls}__toggle`}
                    checked={isChecked || checked}
                    icons={icons}
                    onChange={this.handleChange}
                />
            </div>
        );
    }

    handleChange = () => {
        const { id, name, value, onChange } = this.props;
        const payload = { id, name, value };

        onChange(payload);
    };

    getProps = () => {
        const {
            busy,
            isBusy,
            disabled,
            isDisabled,
            checked,
            isChecked,
            ...rest
        } = this.props;
        const toggleSwitchProps = { ...rest };
        delete toggleSwitchProps.className;
        delete toggleSwitchProps.contextCls;
        delete toggleSwitchProps.busyIconCls;
        delete toggleSwitchProps.onChange;
        delete toggleSwitchProps.checked;
        delete toggleSwitchProps.isChecked;
        delete toggleSwitchProps.readOnly;
        delete toggleSwitchProps.isReadOnly;
        toggleSwitchProps.disabled = busy || isBusy || disabled || isDisabled;

        return toggleSwitchProps;
    };

    baseCls = 'fluid-toggle-switch';
}

export default ToggleSwitch;
